import React, { useEffect, useRef, useState } from 'react'
import { useSelector } from 'react-redux'
import cn from 'classnames'

import { IPostComment, ICommentProps } from 'interfaces'
import { EVENT_TYPE_POST_COMMENT_REPLY } from 'config/app'
import * as userSelectors from 'containers/User/user-selectors'
import { useInvalidateComments } from 'containers/Comments/hooks'
import { UserMessageFormWrap, Button } from 'components'
import { CommentAction } from 'form-actions'
import { scrollTo } from 'utils/helpers'
import eventBus from 'utils/EventBus'
import style from './CommentForm.module.css'

type CommentFormPropType = {
    classes?: string
    postId: number
}

const CommentForm: React.FC<CommentFormPropType> = ({ classes, postId }) => {
    const ref = useRef<HTMLDivElement>(null)

    const user = useSelector(userSelectors.user)

    const [commentProps, setCommentProps] = useState<ICommentProps>({ postId, comment: '', parent: undefined })
    const [parentComment, setParentComment] = useState<IPostComment>()

    const { invalidate: invalidateComments } = useInvalidateComments({ postId })

    const handlerCompleteComment = () => {
        resetCommentProps()
        invalidateComments()
    }

    const handlerCommentReplyCancel = () => {
        resetCommentProps()
    }

    const handlerEventPostCommentReply = ({ parent }: { parent: IPostComment }) => {
        setCommentProps((prevState) => ({ ...prevState, parent: parent.id }))
        setParentComment(parent)
        setTimeout(() => scrollTo(ref?.current?.offsetTop))
    }

    function resetCommentProps() {
        setCommentProps((prevState) => ({ ...prevState, comment: '', parent: undefined }))
        setParentComment(undefined)
    }

    useEffect(() => {
        eventBus.on(EVENT_TYPE_POST_COMMENT_REPLY, handlerEventPostCommentReply)

        return () => {
            eventBus.off(EVENT_TYPE_POST_COMMENT_REPLY, handlerEventPostCommentReply)
        }
    }, [])

    return (
        <div className={cn(style.form, classes)} ref={ref}>
            {parentComment && (
                <div className={style.textReply}>
                    <Button
                        classes={style.textReplyClose}
                        styleType="transparent"
                        onClick={handlerCommentReplyCancel}
                    >
                        <span className={style.textReplyCloseIcon} />
                    </Button>

                    <div className={style.textReplyBody}>
                        <div className={style.textReplyUser}>
                            {parentComment?.user?.name}
                            {' '}
                            {parentComment?.user?.surname}
                        </div>
                        <div className={style.textReplyComment}>
                            {parentComment?.comment}
                        </div>
                    </div>
                </div>
            )}

            <UserMessageFormWrap classes={style.formFieldWrap} user={user}>
                <CommentAction
                    commentProps={commentProps}
                    onComplete={handlerCompleteComment}
                />
            </UserMessageFormWrap>
        </div>
    )
}

export default CommentForm
